import { render, staticRenderFns } from "./Sponsored.vue?vue&type=template&id=ae92918e&scoped=true"
import script from "./Sponsored.vue?vue&type=script&lang=js"
export * from "./Sponsored.vue?vue&type=script&lang=js"
import style0 from "./Sponsored.vue?vue&type=style&index=0&id=ae92918e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@6.26.3_cache-loader@4.1.0_webpac_6f95da160c08ac8dc5724deda4dd3901/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae92918e",
  null
  
)

export default component.exports